import React from "react";
import styled from "styled-components";

interface iProps {
  img: string;
  step: string;
  title: string;
  sub: string;
  bg: string;
  col: string;
  link? : any
 
}

const Steps: React.FC<iProps> = ({ img, step, title, sub, bg, col ,link  }) => {
  return (
    <div>
      <CardDetails >
        <Card>
          <img src={img} alt="" />
        </Card>
        <TextHold>
        <a href={`${link}`}>
        <Step col={col} bg={bg}>
            {step}{" "}
          </Step>
        </a>
         
          <Title>{title} </Title>
          <Sub>{sub} </Sub>
        </TextHold>
      </CardDetails>
    </div>
  );
};

export default Steps;

const Step = styled.button<{ bg: string; col: string }>`
  width: 150px;
  height: 50px;
  border-radius: 30px;
  border: none;
  outline: none;
  margin-bottom: 20px;
  background-color: ${(props) => props.bg};
  color: #000000a6;
  /* color: ${(props) => props.col}; */
  font-weight: bold;
  /* box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px; */
  font-size: 12px;
`;

const Sub = styled.div`
  margin-bottom: 20px;
  font-size: 13px;
  color: #000000ca;
  width: 200px;
  text-align: center;
  font-weight: 500;
`;

const Title = styled.div`
  margin-bottom: 20px;
  font-weight: 700;
  color: #000000df;
`;

const TextHold = styled.div``;

const Card = styled.div`
  width: 150px;
  height: 150px;
  margin-bottom: 50px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
  }
`;

const CardDetails = styled.div`
  width: 300px;
  height: 400px;
  
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
  margin: 10px;
`;
